import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CloseIcon, IconButton } from '@breathelife/mui';
import { ImageTypes, LoaderOverlay } from '@breathelife/ui-components';

import Typography from '../../../../Components/Typography';
import { Icon } from '../../../Icons';
import { JetDecisionOutcomeAccordion } from './JetDecisionOutcomeAccordion';
import { AccordionWrapper, ButtonWrapper, Container, WidgetBody, WidgetHeader } from './Styles';
import { useJetDecisionOutcomes } from '../../../../Hooks/useJetDecisionOutcomes';

export function JetDecisionWidget(): React.ReactElement {
  const { t } = useTranslation();
  const [isWidgetOpen, setIsWidgetOpen] = useState<boolean>(false);
  const { isFetching, jetDecisionOutcomes } = useJetDecisionOutcomes();

  return isWidgetOpen ? (
    <Container>
      <WidgetHeader>
        <Typography variant='h4'>{t('assistedApplication.jetDecisionWidget.title')}</Typography>
        <IconButton key='close' aria-label='Close' onClick={() => setIsWidgetOpen(false)} size='large'>
          <CloseIcon />
        </IconButton>
      </WidgetHeader>
      <WidgetBody>
        <LoaderOverlay isLoading={isFetching}>
          <AccordionWrapper>
            {jetDecisionOutcomes &&
              jetDecisionOutcomes.map((jetDecisionOutcome) => (
                <JetDecisionOutcomeAccordion key={jetDecisionOutcome.participantId} {...jetDecisionOutcome} />
              ))}
          </AccordionWrapper>
        </LoaderOverlay>
      </WidgetBody>
    </Container>
  ) : (
    <ButtonWrapper>
      <IconButton key='open' aria-label='Open' onClick={() => setIsWidgetOpen(true)} size='large'>
        <Icon
          name='circleSendIcon'
          imageType={ImageTypes.meaningful}
          ariaLabel={t('assistedApplication.jetDecisionWidget.open')}
        />
      </IconButton>
    </ButtonWrapper>
  );
}
